<template>
  <small
    v-if="entity.LastModifiedBy"
    class="last-modified-by">
    Last modified by
    {{entity.LastModifiedBy.TransactUser.UserGivenName}}
    on
    {{entity.LastModifiedBy.TransactUtc | date}}
  </small>
</template>

<script>
export default {
  name: 'LastModifiedBy',
  props: ['entity'],
};
</script>

<style lang="scss"></style>
